import ComingSoonFeature from "../../../components/common/ComingSoonFeature";

const Assessments = () => {
  return (
    <ComingSoonFeature
      featureName="ASSESSMENTS"
      skeletonType="list"
      description="Advanced settings management and analytics coming soon!"
      height={650}
    />
  );
};

export default Assessments;
